import extranetClient from "../client";

const isAbleToRegister = async (numSS, ssKey, nom, birthdate ) => {
    try {
        return await extranetClient.post("insured/verify/data", {
            json: {
                numSS: numSS,
                ssKey: ssKey,
                lastname: nom,
                birthdate: birthdate,
            }
        }).json();
    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}

const verifyEmail = async (email) => {
    try {
        return await extranetClient.post("insured/verify/email", {
            json: {
                email: email
            }
        }).json();
    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}

const createInsuredAccount = async (email, lastname, firstname, numSS, ssKey, password, data) => {
    try {
        return await extranetClient.post("insured/verify/create", {
            json: {
                email: email,
                lastname: lastname,
                firstname: firstname,
                numSS: numSS,
                keySS: ssKey,
                password: password,
                data: data
            }
        }).json();
    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}

const resendActivationMail = async (activationToken) => {
    try {
        return await extranetClient.get(`insured/verify/resend-activation-mail/${activationToken}`).json();
    } catch (error) {
        if (error.name === 'HTTPError') {
            return await error.response.json();
        }
    }
}

export default {
    resendActivationMail,
    createInsuredAccount,
    isAbleToRegister,
    verifyEmail
}